export const ListIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 23 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_37_79)">
				<path d="M8 6H26" stroke="black" strokeLinecap="round" />
				<path d="M8 12H26" stroke="black" strokeLinecap="round" />
				<path d="M8 18H26" stroke="black" strokeLinecap="round" />
			</g>
			<g clipPath="url(#clip1_37_79)">
				<path d="M3 6H21" stroke="black" strokeLinecap="round" />
				<path d="M3 12H21" stroke="black" strokeLinecap="round" />
				<path d="M3 18H21" stroke="black" strokeLinecap="round" />
			</g>
			<defs>
				<clipPath id="clip0_37_79">
					<rect width="18" height="24" fill="white" transform="translate(5)" />
				</clipPath>
				<clipPath id="clip1_37_79">
					<rect width="5" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
